// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"683":"9e309290","740":"fd7dc773"}[chunkId] + ".chunk.css";
};